import { dbh_ajax } from "Ressources/dbh_ajax";
import { dbh_helper } from "../src/dbh_helper";

export class dbh_suchergebnis {
    reloadSearchResult(form, target, paramString, action, controller, callback?: Function) {
        var ajax: dbh_ajax = new dbh_ajax();

        if ($(target).parent().hasClass("dbhSuchergebnisWrapper")) {
            target = $(target).parent();
        }

        ajax.sendPostRequest({
            csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
            actionName: action,
            controllerName: controller,
            parameter: paramString,
            callbackSuccess: (ajaxResult) => {
                $(target).html(ajaxResult);
                this.checkSwitchViewStates();
                if (callback) { callback(); };

                if (dbh_helper.OnSetDefaultFormValues) {
                    dbh_helper.OnSetDefaultFormValues();
                }

                this.restoreTableHeader();
                this.setMouseWheelClick();
            },
            callbackError: (ajaxResult) => {
                //console.log(ajaxResult);
            }
        });
    }

    defaultReloadSearchResult(obj, callback?: Function) {
        var a = $(obj);
        var form = null;
        form = dbh_helper.findNearestForm(obj);
        var parents = $(obj).parents('.dbhSuchergebnis');
        if ($(obj).hasClass('dbhSuchergebnis')) {
            parents = $(obj);
        }

        this.reloadSearchResult(form, parents, dbh_helper.getParameterString(a.attr('data-order'), a.attr('data-page'), a.attr('data-page-size'), this.getViewSwitchState(obj), form, a.attr('data-wherekey')), a.attr('data-action'), a.attr('data-controller'), callback)
    }

    getViewSwitchState(obj) {
        if ($(obj).hasClass('dbhSuchergebnis')) {
            $(obj).find('#hdnViewSwitchState').val();
        } else {
            $(obj).parents('.dbhSuchergebnis').find('#hdnViewSwitchState').val();
        }
    }

    checkSwitchViewStates() {
        // Kachelansicht nach Postback?
        $('.dbhSuchergebnis').each(function (index, elem) {
            if (parseInt($(elem).find('#hdnViewSwitchState').val() as string) == 1) {
                $(elem).find('.dbhSuchergebnisTabelle').removeClass("active").addClass("hidden");
                $(elem).find('.dbhSuchergebnisKacheln').removeClass("hidden").addClass("active");
                $(elem).find('.dbhBtnKachelansicht').addClass("active");
                $(elem).find('.dbhBtnTabellenansicht').removeClass("active");
            }
        });
    }

    setMouseWheelClick() {
        // catch mousewheel clicked to open in new tab
        $('.dbhSuchergebnisTabelle tr td').on("mousedown", function (e) {
            if (e.button === 1) {
                //console.log("Mausrad");
                e.preventDefault();
                e.stopPropagation();
                var link = $(this).attr("onclick");
                var url = link.substr(link.indexOf("=") + 1).replace(/\'/g, "").trim();
                //console.log(url);
                window.open(url, '_blank').focus();
            }
        });
    }

    restoreTableHeader() {
        if ($('.btnRowImportToTableHeader') && $('.btnRowImportToTableHeader').length > 0) {
            // Buttons sollen im Tabellen-Header stehen, daher werden diese hier dynamisch eingefügt
            $('.btnRowImportToTableHeader').first().hide();
            var C = $('.btnRowImportToTableHeader').first().clone(true, true);
            C.show();
            C.insertBefore($('.dbhTable-headlineContainer .dbhTable-ButtonContainer').first().children().first());
        }
    }
}

var EventKeypressReminder = null;

$(document).ready(function () {

    $(document).on('click', '.dbh_pageTableHeader:not(.btnColumn)', function () {
        var a = $(this);
        var hasSearchForm: boolean = a.attr('data-hassearchform') != null && a.attr('data-hassearchform') != undefined ? a.attr('data-hassearchform').toLowerCase() == 'true' : false;
        var form = null;
        //if (hasSearchForm != null && hasSearchForm != undefined && hasSearchForm == true) {
        form = dbh_helper.findNearestForm(this);
        //}

        var orderNew = a.attr('data-order');
        var orderOld = a.attr('data-order-old');
        if (orderNew != "1" && orderOld.toString().toLowerCase().trim() == orderNew.toString().toLowerCase().trim()) {
            orderNew += " DESC";
        }

        var suchergebnis = new dbh_suchergebnis();
        suchergebnis.reloadSearchResult(form, $(this).parents('.dbhSuchergebnis'), dbh_helper.getParameterString(orderNew, a.attr('data-page'), a.attr('data-page-size'), suchergebnis.getViewSwitchState(this), form, a.attr('data-wherekey')), a.attr('data-action'), a.attr('data-controller'))
    });
    $(document).on('click', '.dbh_pageSwitch', function () {
        new dbh_suchergebnis().defaultReloadSearchResult(this);
    })
    $(document).on('click', '.dbhBtnTabellenansicht', function (e) {
        const suchergebnisElem = $(this).parents('.dbhSuchergebnis');
        suchergebnisElem.find('.dbhBtnTabellenansicht').addClass("active");
        suchergebnisElem.find('.dbhBtnKachelansicht').removeClass("active");
        suchergebnisElem.find('.dbhSuchergebnisTabelle').removeClass("hidden").addClass("active");
        suchergebnisElem.find('.dbhSuchergebnisKacheln').removeClass("active").addClass("hidden");
        suchergebnisElem.find('#hdnViewSwitchState').val(0);

        //defaultReloadSearchResult(this);
        //e.preventDefault();
    })
    $(document).on('click', '.dbhBtnKachelansicht', function (e) {
        const suchergebnisElem = $(this).parents('.dbhSuchergebnis');
        suchergebnisElem.find('.dbhBtnKachelansicht').addClass("active");
        suchergebnisElem.find('.dbhBtnTabellenansicht').removeClass("active");
        suchergebnisElem.find('.dbhSuchergebnisTabelle').removeClass("active").addClass("hidden");
        suchergebnisElem.find('.dbhSuchergebnisKacheln').removeClass("hidden").addClass("active");
        suchergebnisElem.find('#hdnViewSwitchState').val(1);
        //defaultReloadSearchResult(this);
        //e.preventDefault();
    })

    new dbh_suchergebnis().checkSwitchViewStates();
    new dbh_suchergebnis().setMouseWheelClick();

    //$(document).on('change', '.dbhSucheUeberTabelle input', function () {
    //    if (EventKeypressReminder != null) {
    //        window.clearTimeout(EventKeypressReminder);
    //    }
    //    var a = $(this);
    //    EventKeypressReminder = window.setTimeout(function () {
    //        defaultReloadSearchResult(a.parent());
    //        console.log(a);
    //        window.setTimeout(function () {
    //            a.focus();
    //            console.log(a);
    //        }, 500);
    //    }, 500);
    //})

    /*keyup: war vorher keypress, allerdings feuert dann das Event nicht bei "Return" */
    $(document).on('keyup', '.dbhSucheUeberTabelle input', function (e) {
        if ($(this).hasClass("ignoreSubmit")) {
            /*Neuladen der Ergebnisse vermeiden*/
            return;
        }

        if (e.keyCode === 10 || e.keyCode === 13) {
            e.preventDefault();
        }
        if (EventKeypressReminder != null) {
            window.clearTimeout(EventKeypressReminder);
        }
        var a = $(this);
        EventKeypressReminder = window.setTimeout(function () {
            const id = $(a).attr('id');
            const value = $(a).val();

            const parent = a.closest(".dbhSuchergebnis");
            const inputElements = parent.find(`[name='${id}']`);
            inputElements.val(value);

            new dbh_suchergebnis().defaultReloadSearchResult(a.parent());

            if (id != undefined && id != '') {
                window.setTimeout(function () {
                    // set Cursor 
                    $("#" + id).focus().val('').val(value);
                }, 200);
            }
        }, 500);
    });

    $(document).on('change', '.dbhSucheUeberTabelle input[type="checkbox"]', function (e) {
        const a = $(this);
        const id = $(a).attr('id');
        const value = $(a).val();
        new dbh_suchergebnis().defaultReloadSearchResult($(this).parent());
        if (id != undefined && id != '') {
            window.setTimeout(function () {
                $("#" + id).find("input[value='" + value + "']").prop("checked", true);
            }, 200);
        }
    });
    $(document).on('change', '.dbhSucheUeberTabelle input[type="radio"]', function (e) {
        const $radio = $(this);
        const id = $radio.attr('id');
        const name = $radio.attr("name");

        /*Damit Sortierung und Anzeige bei Detailsuche funktioniert (z.B. BelegungDetails -> zugewiesene Betreuer) 
         * erhalten die Kachel-Elemente einen anderen Namen (mit der Erweiterung '_tile') Damit die Suche in der mobilen
         * Ansicht dann noch funktioniert, müssen die nicht-Kachel-Elemente bei change angepasst werden*/
        if (name.indexOf("_tile") >= 0) {
            const otherName = name.replace('_tile', '');
            const value = $radio.val();

            const $otherRadio = $(`[name='${otherName}']`);
            if ($otherRadio.length > 0) {
                for (let i = 0; i < $otherRadio.length; i++) {
                    const $curOtherRadio = $($otherRadio[i]);
                    if ($curOtherRadio.val() === value) {
                        $curOtherRadio.attr("checked", "checked");
                    }
                }
            }
        }

        new dbh_suchergebnis().defaultReloadSearchResult($(this).parent().parent().parent(), () => {
            $("#" + id).prop("checked", true);
            const $eventRebinder = $("#eventRebinderTrigger");
            if ($eventRebinder.length > 0) {
                $eventRebinder.trigger("click");
            }
        });
    });
})

